'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # repeat
 * String.repeat() polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat#Polyfill
 *
 * @param {String} string
 * @param {Number} count
 * @return  {String}
 *
 * @example
 * repeat('Hello World!', 5);
 *
 * @module helpers/polyfill/repeat.js
 */
function repeat(string, count) {
  var str = '' + string;
  count = +count;

  if (count !== count) {
    count = 0;
  }

  if (count < 0) {
    throw new RangeError('repeat count must be non-negative');
  }

  if (count === Infinity) {
    throw new RangeError('repeat count must be less than infinity');
  }

  count = Math.floor(count);

  if (str.length === 0 || count === 0) {
    return '';
  }

  // Ensuring count is a 31-bit integer allows us to heavily optimize the
  // main part. But anyway, most current (August 2014) browsers can't handle
  // strings 1 << 28 chars or longer, so:
  if (str.length * count >= 1 << 28) {
    throw new RangeError('repeat count must not overflow maximum string size');
  }

  var maxCount = str.length * count;
  count = Math.floor(Math.log(count) / Math.log(2));

  while (count) {
    str += str;
    count--;
  }

  str += str.substring(0, maxCount - str.length);

  return str;
}

exports.default = repeat;
module.exports = exports['default'];
//# sourceMappingURL=repeat.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/helpers/polyfill/repeat.js
// module id = 1829
// module chunks = 0